
import { openServiceAuth } from '@/settings'
export default {
	inject: ['dialogInstance'],
	components: {},
	data() {
		return {
			qrcode: '',
			showWx: false
		}
	},
	watch: {},

	methods: {
		getQrcode() {
			let data = {
				publicKey: 'WECHAT_OFFICIAL_GLOBAL_CONFIG'
			}
			this.dialogInstance.$api.sysGetConfig(data).then(val => {
				if (val.data == 'TRUE') {
					this.dialogInstance.$api.getBindingQrCodeUrl().then(res => {
						if (!res.success) {
							this.$message.error(res.info)
							return
						}
						this.qrcode = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + res.data.ticket
					})
				}
			})
		},
		/**
		 * 绑定微信公众号
		 */
		async onBindShowWeChat() {
			let data = {
				publicKey: 'WECHAT_OFFICIAL_GLOBAL_CONFIG'
			}
			const valid = await this.dialogInstance.$api.sysGetConfig(data)
			if (!valid.success) {
				this.$message.error(valid.info)
				return
			}
			const open = valid.data === 'TRUE'
			if (!open) return
			const userInfo = JSON.parse(localStorage.getItem('setuserinfo')) || {}
			if (openServiceAuth && !userInfo.token) return
			const isOfficialAccount = userInfo?.isOfficialAccount || false
			if (!isOfficialAccount) {
				this.showWx = true
			}
		}
	},
	created() {
        this.getQrcode()
    },
	mounted() {
		this.onBindShowWeChat()
	}
}
